import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { NgxFileDropModule, NgxFileDropEntry } from 'ngx-file-drop';
import { NgClass } from '@angular/common';
import type { UploadedFreezeFile } from '../../services/freeze-file.service';
import { FreezeFileService } from '../../services/freeze-file.service';
import type { FreezeReason } from '../../models/freeze-reason.model';

@Component({
  selector: 'freeze-file-upload',
  templateUrl: './freeze-file-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    ButtonModule,
    ProgressSpinnerModule,
    MessageModule,
    TooltipModule,
    NgxFileDropModule,
    NgClass,
  ],
})
export class FreezeFileUploadComponent {
  private fileService = inject(FreezeFileService);

  readonly uploadedFiles = input<UploadedFreezeFile[]>([]);
  readonly isUploading = input<boolean>(false);
  readonly selectedFreezeReason = input<FreezeReason | null>(null);

  readonly fileSelected = output<NgxFileDropEntry[]>();
  readonly fileRemoved = output<number>();

  get acceptedFileTypes(): string[] {
    return this.fileService.acceptedFileTypes;
  }

  onFileDrop(files: NgxFileDropEntry[]): void {
    this.fileSelected.emit(files);
  }

  onRemoveFile(index: number): void {
    this.fileRemoved.emit(index);
  }

  getFileIcon(file: File): string {
    return this.fileService.getFileIcon(file);
  }

  getFileSize(file: File): string {
    return this.fileService.getFileSize(file);
  }

  isImageFile(file: File): boolean {
    return this.fileService.isImageFile(file);
  }
}
